export default {
    "TTK": {
        "Text": "Triathlon Total Knee",
        "Parameters": [
            {
                "TTK.FemoralComponent": {
                    "Text": "Femoral Component",
                    "Items": {
                        "TTK.FemoralComponent.CR": {
                            "Text": "CR"
                        },
                        "TTK.FemoralComponent.PS": {
                            "Text": "PS"
                        }
                    }
                }
            },
            {
                "TTK.InsertType": {
                    "Text": "Insert Type",
                    "Items": {
                        "TTK.InsertType.CR": {
                            "Text": "CR"
                        },
                        "TTK.InsertType.CSPCLProtect": {
                            "Text": "CS (PCL Protect)"
                        },
                        "TTK.InsertType.PS": {
                            "Text": "PS"
                        }
                    }
                }
            },
            {
                "TTK.Baseplate": {
                    "Text": "Baseplate",
                    "Items": {
                        "TTK.Baseplate.Universal": {
                            "Text": "Universal"
                        },
                        "TTK.Baseplate.Cruciform": {
                            "Text": "Cruciform"
                        }
                    }
                }
            }
        ],
        "ImplantData": {
            "TTK.FemoralImplantSize": {
                "Text": "Femoral Implant Size"
            },
            "TTK.TibialImplantSize": {
                "Text": "Tibial Implant Size"
            }
        },
        "ValidCombinations": [
            [ "TTK.FemoralComponent.CR", "TTK.InsertType.CR", "TTK.Baseplate.Cruciform" ],
            [ "TTK.FemoralComponent.CR", "TTK.InsertType.CR", "TTK.Baseplate.Universal" ],
            [ "TTK.FemoralComponent.CR", "TTK.InsertType.CSPCLProtect", "TTK.Baseplate.Cruciform" ],
            [ "TTK.FemoralComponent.CR", "TTK.InsertType.CSPCLProtect", "TTK.Baseplate.Universal" ],
            [ "TTK.FemoralComponent.PS", "TTK.InsertType.PS", "TTK.Baseplate.Cruciform" ],
            [ "TTK.FemoralComponent.PS", "TTK.InsertType.PS", "TTK.Baseplate.Universal" ]
        ]
    }
}